import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=8d70e3d8&scoped=true"
import script from "./DateFilter.vue?vue&type=script&lang=js"
export * from "./DateFilter.vue?vue&type=script&lang=js"
import style0 from "./DateFilter.vue?vue&type=style&index=0&id=8d70e3d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d70e3d8",
  null
  
)

export default component.exports